module.exports = __webpack_public_path__ + "static/media/icon-no-image.72a93121.svg";